import { createRoot } from 'react-dom/client'
import {  createIntl } from "react-intl";
import messagesEn from "./messages/en";
import Index from './Index';
import fetchConfig from './apis/config';

export const intl  = createIntl({ locale: 'en', messages: messagesEn})

fetchConfig().then((config) => { 
  createRoot(document.getElementById('root')!).render(<Index config={config} />);
});
